import {classes} from '@bitstillery/common/lib/utils'
import {Icon} from '../icon/icon'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'

import type {NotificationData} from '../../groups/notification/notifier'

interface NotificationAttrs {
    notification: NotificationData
    key?: string | number
    on_close?: (notification: NotificationData) => unknown
}

export class Notification extends MithrilComponent<NotificationAttrs> {
    view(vn: m.Vnode<NotificationAttrs>) {
        const level = vn.attrs.notification.level || 'default'
        const timeout = vn.attrs.notification.timeout
        return (
            <div className={classes('c-notification', {[`type-${level}`]: true})}>
                <Icon className='notification-icon' name={vn.attrs.notification.icon || 'info'} size='xl' type={level} />
                <div class='message'>
                    <div class='body' innerHTML={vn.attrs.notification.message} />
                </div>
                <Icon
                    className='btn-close'
                    name='close'
                    type={level}
                    onclick={() => {
                        vn.attrs.on_close?.(vn.attrs.notification)
                    }}
                />
                {timeout && timeout > 0 && <div class='countdown' style={`animation-duration: ${timeout}ms`} />}
            </div>
        )
    }
}
